module.exports = __webpack_public_path__ + "tables/media/Typography-dark.c79df574.svg";